module.exports = __webpack_public_path__ + "img/parallax-red.394fd8cb.jpg";